import { CustomOffsetRecord, customOffsetToOption, hardcodedReminderOffsets } from '@shared/core/custom-offsets'
import ms from 'ms'
import { useQuery, UseQueryOptions } from 'react-query'
import { ApiService } from 'src/services/api.service'

export function useReminderOffsets(options?: UseQueryOptions<CustomOffsetRecord[]>) {
  const { data: customOffsets = [] } = useQuery(
    ['custom-offsets', 'reminder'],
    () => ApiService.CustomOffsets.getCustomOffsets('reminder'),
    {
      staleTime: ms('5 minutes'),
      ...options,
    },
  )
  const allOptions = [
    ...hardcodedReminderOffsets,
    ...customOffsets.map((offset) => customOffsetToOption(offset, 'reminder')),
  ]
  allOptions.sort((a, b) => Number(a.value) - Number(b.value))
  return allOptions
}
